import { render, staticRenderFns } from "./chanyejiliangzhongxinDetail.vue?vue&type=template&id=04591ba1&scoped=true"
import script from "./chanyejiliangzhongxinDetail.vue?vue&type=script&lang=js"
export * from "./chanyejiliangzhongxinDetail.vue?vue&type=script&lang=js"
import style0 from "./chanyejiliangzhongxinDetail.vue?vue&type=style&index=0&id=04591ba1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04591ba1",
  null
  
)

export default component.exports